const baseUnit = 8
const typeSpace = 4

export { baseUnit, typeSpace }
